/** Clé TanStack Query pour la configuration CGU (gate + pied de page). */
export const CGU_CONFIG_QUERY_KEY = ["cgu-config"] as const;
